// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"DirectionsView_Wrapper__2ZpdH","Image":"DirectionsView_Image__30mfy","Text":"DirectionsView_Text__3DH03","MapImage":"DirectionsView_MapImage__3Vx6D"};